import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';

export const NonSyariahBannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fdeded;
  gap: 16px;
  border-radius: 4px;
`;

export const NonSyariahBannerDescription = styled(Text).attrs({
  size: '14px',
  color: '#333333',
})`
  line-height: 18px;

  span {
    font-weight: 700;
  }
`;

export const NonSyariahBadgeWrapper = styled.div<{ noMargin?: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid #fdeded;
  border-radius: 2px;
  background: #fdeded;
  padding: 3px 5px;
  margin-left: 7px;
  text-wrap: nowrap;

  ${({ noMargin }) =>
    noMargin &&
    `
    margin: 0px;
  `};
`;

export const NonSyariahBadgeLabel = styled(Text).attrs({
  family: 'bold',
  color: '#EE4A49',
  size: '8px',
})``;
